/* eslint-disable import/prefer-default-export */
export const SERVICE_TYPES = ['maintenance', 'breakdown'];



// WEBPACK FOOTER //
// ./components/WizardSteps/ServiceRequestType/constants.js